import React, { Component } from 'react'
import { connect } from 'react-redux'
import './markaswrecked.scss'

// Components
import Modal from '../../components/Modal'
import Portal from '../../components/Portal'
import Confirm from '../../components/Confirm'

// Actions
import { markAsWrecked } from '../../../actions/orders'
import { createNote } from '../../../actions/notes'
import { invoiceHistory } from '../../../actions/invoicing'

// Utils
import { translation } from '../../../utils/helpers'
import { makeOrderTitle } from '../../../utils/order'
import { renderFullDate } from '../../../utils/time'

// Elements
import Textarea from '../../elements/textarea'
import Inline from '../../elements/inline'

import { ModalIcons } from '../../elements/icons'

class MarkAsWreckedModal extends Component {
  constructor (props) {
    super(props)

    this.state = {
      view: null,
      isLoadingLastHistory: false,
      lastHistory: {},
      comment: ''
    }

    this.onInputChange = this.onInputChange.bind(this)
    this.wreckOrder = this.wreckOrder.bind(this)
    this.onConfirmInvoicedMarkAsWrecked = this.onConfirmInvoicedMarkAsWrecked.bind(this)
    this.renderConfirmInvoicedMarkAsWrecked = this.renderConfirmInvoicedMarkAsWrecked.bind(this)
  }

  componentDidMount () {
    if (this.props.order.IsInvoiced) {
      this.setState({
        view: 'invoicedConfirm',
        isLoadingLastHistory: true
      }, () => {
        this.props.invoiceHistory(this.props.order.Id).then((res) => {
          this.setState({
            lastHistory: res.data,
            isLoadingLastHistory: false
            // }, { () => console.log('[OrderActions][loadinglasthistory]', this.state)
          })
        })
      })
    } else {
      this.setState({
        view: 'wreck'
      })
    }
  }

  onInputChange (e) {
    this.setState({
      comment: e.target.value
    })
  }

  wreckOrder () {
    const wreckIt = () => {
      // Mark as wrecked
      this.props.markAsWrecked(this.props.order.Id).then(res => {
        // window.toastr.success(translation('15241'), translation('13424'))
        if (this.props.onMoveSuccess) {
          this.props.onMoveSuccess(res.data, res.data.Orders)
        }
        this.props.onClose()
      }, () => {
        window.toastr.error(translation('960'), translation('216'))
      })
    }

    if (this.state.comment) {
      const newNote = {
        Note: this.state.comment,
        OrderID: this.props.order.Id,
        SourceID: 20
      }

      // Save comment
      this.props.createNote(newNote).then(() => {
        wreckIt()
      }, () => {
        window.toastr.error(translation('960'), translation('216'))
      })
    } else {
      wreckIt()
    }
  }

  renderConfirmInvoicedMarkAsWrecked () {
    let resendText = translation('14950') + '.'
    if (this.state.isLoadingLastHistory) {
      resendText = ''
    }
    let name = this.state.lastHistory.UserName
    let date = renderFullDate(this.state.lastHistory.Date)

    return (
      <div>
        <div className='pg-mb-1'>{resendText}</div>
        <Inline block fillChildNum={[0]}>
          <div>{translation('14937')}</div>
          <div>{name}</div>
        </Inline>
        <Inline block fillChildNum={[0]}>
          <div>{translation('14938')}</div>
          <div>{date}</div>
        </Inline>
        <div className='pg-mb-1'>{translation('14927')} {translation('15238')}</div>
      </div>
    )
  }

  onConfirmInvoicedMarkAsWrecked () {
    this.setState({
      view: 'wreck'
    })
  }

  renderView () {
    return (
      <div>
        <span>{translation('15240')}</span>
        <Textarea name='comment' value={this.state.comment} onChange={this.onInputChange} labelText={translation('15197')} />
      </div>
    )
  }

  render () {
    const orderTitle = makeOrderTitle(this.props.order, null, null, true)
    const header = `${translation('15239')} - ${orderTitle}`

    return (
      <div className='totalwreck'>
        {this.state.view === 'wreck' && (
          <Modal {...this.props}
            header={header}
            overflowHidden={false}
            onClose={this.props.onClose}
            icon={ModalIcons.Total_Wreck}
            bottomBarProps={{
              actionLabelText: translation('752'),
              onActionClick: this.wreckOrder,
              cancelLabelText: translation('1155'),
              onCancelClick: this.props.onClose
            }}
          >
            {this.renderView()}
          </Modal>
        )}

        {this.state.view === 'invoicedConfirm' && (
          <Portal className='resendModal' onPortalClose={() => {}}>
            <Confirm
              renderText={this.renderConfirmInvoicedMarkAsWrecked}
              confirm={this.onConfirmInvoicedMarkAsWrecked}
              notConfirm={this.props.onClose}
              disabled={this.state.isLoadingLastHistory} />
          </Portal>
        )}
      </div>
    )
  }
}

export default connect(null, {
  markAsWrecked,
  createNote,
  invoiceHistory
})(MarkAsWreckedModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/MarkAsWreckedModal/index.js